module.exports = __webpack_public_path__ + "img/kneron-logo.33f21248.png";